import {h, Fragment} from 'preact';

export default function AutoAnswer({answers}){
	return (
		<Fragment>
			<section className="auto-answer-block">
				<div className="answer">
					<div className="answer__list">
						{
							answers.map((item, key) => {
								return (
									<div className="answer__item" key={key}>
										<a className="answer__link" target="_blank" href={item.content} dangerouslySetInnerHTML={{__html: item.title}}/>
									</div>
								);
							})
						}
					</div>
				</div>
			</section>
		</Fragment>
	)
}